import { useModal } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import classNames from 'classnames';
import { ActivitiesService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import messages from './ReassignActivity.messages';
import metadata from './ReassignActivity.metadata.json5';
import styles from './ReassignActivity.module.scss';

const ReassignActivity = ({ activity, onUpdateActivity }) => {
    const { showAlert } = useModal();

    const authHeader = _.get(useAuthentication(), 'authHeader');
    const [selectedValue, setSelectedValue] = useState('');
    const [editable, setIsEditable] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const activityWrapperStyle = classNames(styles.gwReassignActivityWrapper, {
        [styles.gwReassignActivityDisplay]: activity.canReassign,
    });

    const writeValue = useCallback(
        value => {
            setSelectedValue(value);
        },
        [setSelectedValue]
    );

    const getNewSortedList = ((au) => {
        const sortedList = _.sortBy(au);
        
        sortedList.forEach((item,i) =>{
            if(item === "Me"){
            sortedList.splice(i, 1);
            sortedList.unshift(item);
            }
        });

        return sortedList;
    });

    const getAvailableAssignableUser = useCallback(activities => (
            activities?.assignableUsers && 
            getNewSortedList(activities.assignableUsers).map(availableUser => ({
                    code: availableUser,
                    name: availableUser,
                }))
    ), []);

    const enableEditing = useCallback(async () => {
        if (activity.canReassign && activity.status !== 'complete') {
            if(_.isEmpty(activity.assignableUsers) && _.isNull(activity.assignableUsers)){
                const response = await ActivitiesService.getAssignableUsers_TWIA(activity.publicID, authHeader);
                
                _.set(activity, 'assignableUsers', response);
                
                getAvailableAssignableUser(activity);
            }

            setIsEditable(true);
        }
    }, [activity, authHeader, getAvailableAssignableUser]);    
    
    const resetAfterReassign = useCallback(() => {
        setLoading(false);
        setSelectedValue('');
        setIsEditable(false);
    }, [setLoading, setSelectedValue, setIsEditable]);
    const assignToSelectedUser = useCallback(async () => {
        setLoading(true);
        ActivitiesService.reassignActivity(
            selectedValue,
            activity.publicID,
            authHeader
        )
            .then(response => {
                onUpdateActivity(response);
                resetAfterReassign();
            })
            .catch(error => {
                resetAfterReassign();

                const errorMessage = _.get(
                    error,
                    'baseError.data.error.message'
                );
                
                if (errorMessage) {
                    showAlert({
                        title: messages.unableToReassign,
                        message: error.baseError.data.error.message,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                }
            });
    }, [selectedValue, activity.publicID, authHeader, onUpdateActivity, resetAfterReassign, showAlert]);
    const disableEditing = useCallback(() => {
        setSelectedValue('');
        setIsEditable(false);
    }, [setIsEditable, setSelectedValue]);

    const overrideProps = {
        assignableUserList: {
            availableValues: getAvailableAssignableUser(activity),
            value: selectedValue,
        },
        reassignActivityWrapper: {
            visible: !editable,
            className: activityWrapperStyle,
        },
        selectUserContainer: {
            visible: editable,
        },
        assignedName: {
            content: _.get(activity, 'assignedTo.displayName'),
        },
        reassignPageLoader: {
            loaded: !isLoading,
            visible: isLoading,
        },
        activityReassignContainer: {
            visible: !isLoading,
        },
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleValueChange: writeValue,
            enableEditing,
            disableEditing,
            assignToSelectedUser,
            onClickPrevent: e => e.stopPropagation(),
        },
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
};

ReassignActivity.propTypes = {
    activity: PropTypes.shape({}).isRequired,
    onUpdateActivity: PropTypes.func,
};

export default ReassignActivity;
